export default __webpack_public_path__ + "static/link-to-icon--white-803ffed6ccf2efa67b35e1f253b1016b.svg";